import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { DetailedEnvelopeMantyStatusHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Envelope/MantyStatusHypothesis/helpers/types';
import EnvelopeMantyStatusHypothesisDisplay from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Envelope/MantyStatusHypothesis/EnvelopeMantyStatusHypothesisDisplay';
import { HypothesesAccordion } from './HypothesesAccordion';

type Props = {
    envelopeMantyStatusHypotheses: DetailedEnvelopeMantyStatusHypothesis[];
    excludedMantyStatusHypotheses?: number[];
    setExcludedMantyStatusHypotheses?: (
        excludedMantyStatusHypotheses: number[],
    ) => void;
};
const NonRecurrentEnvelopes = ({
    envelopeMantyStatusHypotheses,
    excludedMantyStatusHypotheses,
    setExcludedMantyStatusHypotheses,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    const dataLength = envelopeMantyStatusHypotheses
        .map((item) => Object.keys(item.newValuesByDates).length)
        .reduce((acc, val) => acc + val, 0);

    return (
        <HypothesesAccordion
            title={t('humanResources.simulation.nonRecurrentEnvelopesResume')}
            badgeContent={dataLength}
        >
            <Box
                sx={{
                    margin: '1rem',
                }}
            >
                {envelopeMantyStatusHypotheses.length === 0 ? (
                    t(
                        'humanResources.simulation.duplicateSimulation.noHypothesis',
                    )
                ) : (
                    <Box
                        sx={{
                            maxHeight: '200px',
                            overflowY: 'auto',
                        }}
                    >
                        {envelopeMantyStatusHypotheses.map(
                            (hypothesis, index) => (
                                <Box key={index} sx={{ marginBottom: '2rem' }}>
                                    <EnvelopeMantyStatusHypothesisDisplay
                                        hypothesis={hypothesis}
                                        excludedMantyStatusHypotheses={
                                            excludedMantyStatusHypotheses
                                        }
                                        setExcludedMantyStatusHypotheses={
                                            setExcludedMantyStatusHypotheses
                                        }
                                    />
                                </Box>
                            ),
                        )}
                    </Box>
                )}
            </Box>
        </HypothesesAccordion>
    );
};

export default memo(NonRecurrentEnvelopes);
